import styled from 'styled-components';

const Div = styled.div``;

const Span = styled.span``;

const SelectHeader = styled.div`
  color: ${({ error, theme }) =>
    error ? theme.COLOR_ERROR_TEXT : theme.COLOR_GREY_TEXT};
  font-size: ${(props) => props.fontSize || '12px'};
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.4px;
`;

const Container = styled.div`
  margin: ${(props) => (props.margin ? props.margin : '0')};
  width: 100%;
`;

const Validation = styled.div`
  width: 100%;
  color: grey;
  font-size: 12px;
  line-height: auto;
  margin: 0;
  padding-left: 5px;
  margin-bottom: 1%;
  overflow: visible;
  white-space: wrap;
`;

const GroupContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 2px;
`;

const CheckboxContainer = styled.label`
  cursor: pointer;
  span {
    white-space: nowrap;
  }
  display: block;
  position: relative;
  padding-left: 25px;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '16px')};
  white-space: ${(props) => (props.whiteSpace ? props.whiteSpace : 'normal')};
  text-overflow: ${(props) =>
    props.textOverflow ? props.textOverflow : 'initial'};
  overflow: ${(props) => (props.overflow ? props.overflow : 'initial')};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: ${(props) => (props.width ? props.width : 'fit-content')};
  margin: ${(props) => (props.margin ? props.margin : '0')};
  color: ${(props) => props.theme.checkBoxBorderColor};
  &:hover {
    input ~ .checkMark {
      &:after {
        opacity: 0.3;
      }
    }
  }
`;

const CheckBox = styled.input`
  position: absolute;
  padding: 24px 0 24px 0;
  opacity: 0;
  height: 0px;
  width: 0px;
  &:checked ~ .checkMark {
    background-color: ${(props) => (props.disabled ? '#da0c0c85' : '#da0c0c')};
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    &:after {
      opacity: 1 !important;
    }
  }
`;

const CheckMark = styled.span`
  position: absolute;
  left: 0;
  height: 22px;
  top: 6px;
  width: 22px;
  border: 1px solid #ccd0e3;
  transition: background-color 0.1s ease-in-out;
  &:after {
    left: 6px;
    top: 2px;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    content: '';
    opacity: 0;
    position: absolute;
    transition: opacity 0.1s ease-in-out;
  }
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  width: fit-content;
  margin-bottom: 12px;
  color: ${(props) => props.theme.COLOR_ERROR_TEXT};
`;

const NoErrorMessage = styled.div`
  height: 18px;
  margin-bottom: 12px;
`;

const LabelSpan = styled.span`
  margin-left: 32px;
  white-space: normal !important;
  color: ${(props) => props.theme.inputHeaderColor};
`;

const styledSelect = {
  Container,
  Validation,
  GroupContainer,
  Div,
  Span,
  SelectHeader,
  CheckMark,
  CheckboxContainer,
  NoErrorMessage,
  LabelSpan,
  CheckBox,
  ErrorMessage,
};

export default styledSelect;
